import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M4.46693 9C4.46693 6.51746 6.44347 4.5 8.88765 4.5C10.4309 4.5 11.7893 5.30444 12.5805 6.52522H11.6355C11.2305 6.52522 10.9021 6.861 10.9021 7.27522C10.9021 7.68943 11.2305 8.02522 11.6355 8.02522L14.2665 8.02522C14.6716 8.02522 15 7.68943 15 7.27522V4.5849C15 4.17069 14.6716 3.8349 14.2665 3.8349C13.8615 3.8349 13.5331 4.17069 13.5331 4.5849V5.31341C12.456 3.90592 10.7755 3 8.88765 3C5.63867 3 3 5.68355 3 9C3 12.3164 5.63867 15 8.88765 15C11.8883 15 14.3671 12.712 14.7297 9.74941C14.7801 9.3384 14.495 8.96351 14.0931 8.91206C13.6911 8.86061 13.3245 9.15208 13.2742 9.56309C13.0028 11.78 11.1438 13.5 8.88765 13.5C6.44347 13.5 4.46693 11.4825 4.46693 9Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}